import axios from "axios";

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class PaymentService {
  async getPaymentAsync(authToken) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.get(
        API_URL + `/Payments`,
        { headers: headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async payInvoiceAsync(authToken, request_data) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.post(
        API_URL + `/Payments/Invoice/${request_data.id}/RecordPayment`,
        request_data.data,
        { headers: headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async updateInvoiceAsync(authToken, request_data) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.patch(
        API_URL + `/Payments/Invoice/${request_data.id}/Status`,
        request_data.data,
        { headers: headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default new PaymentService();
